export default "__VITE_ASSET__113afac1__"